import { CobliAxios } from '../../request/CobliAxios';
import HttpMethod from '../../request/HttpMethod';
import type { Configuration, IRequest } from '../../request/Types';
import type { VehiclePassageHistoryApiRequest, VehiclePassageHistoryApiResponse } from './ApiTypes';

export class VehiclePassageHistoryRequester {
  private cobliAxios: CobliAxios;

  constructor(configuration: Configuration) {
    this.cobliAxios = new CobliAxios(configuration);
  }

  public load = async (request: VehiclePassageHistoryApiRequest): Promise<VehiclePassageHistoryApiResponse> => {
    const requestData: IRequest = {
      endpoint: '/analytics/v1/vehicles/locations/history',
      method: HttpMethod.POST,
      body: JSON.stringify({
        latitude: request.latitude,
        longitude: request.longitude,
        distance_radius_in_meters: request.distanceRadiusInMeters,
        start_date: request.startDate,
        end_date: request.endDate,
        timezone: request.timezone,
        size: request.size,
        page: request.page,
      }),
    };

    const result = await this.cobliAxios.request(requestData);
    const payload = result.data.data;

    return payload;
  };
}
